import { w3cwebsocket as W3CWebSocket } from "websocket";


const client = new W3CWebSocket(`${process.env.REACT_APP_SOCKET_URL}`);

export default client;